export default __webpack_public_path__ + "static/media/ver-documento.0ecf3e1d.svg";